__webpack_require__.hmrF = () => ("promo-block-view." + __webpack_require__.h() + ".hot-update.json");